export enum AssignmentCategory {
  CORE = "CORE",
  TEACHER_ASSIGNED = "TEACHER_ASSIGNED",
  AI = "AI",
  ROLLOVER = "ROLLOVER",
}

export enum AssignmentSequence {
  CONTINUE = "CONTINUE",
  BREAK = "BREAK",
}

export enum AssignmentStatus {
  ASSIGNED = "ASSIGNED",
  UNASSIGNED = "UNASSIGNED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETE = "COMPLETE",
  DONE = "DONE",
  ERROR = "ERROR",
}

export const Entity = {
  STUDENT: "STUDENT",
  CLASS: "CLASS",
  SCHOOL: "SCHOOL",
  DISTRICT: "DISTRICT",
  AMIRA_SYSTEM: "AMIRA_SYSTEM",
};

export enum Grade {
  PRE_K = "PRE_K",
  KINDERGARTEN = "KINDERGARTEN",
  FIRST = "FIRST",
  SECOND = "SECOND",
  THIRD = "THIRD",
  FOURTH = "FOURTH",
  FIFTH = "FIFTH",
  SIXTH = "SIXTH",
  SEVENTH = "SEVENTH",
  EIGHTH = "EIGHTH",
}

export enum LessonPeriodType {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
}

export enum Locale {
  EN_US = "EN_US",
  ES_MX = "ES_MX",
}

export enum Season {
  FALL = "FALL",
  WINTER = "WINTER",
  SPRING = "SPRING",
}

export type ActivitySummary = {
  type?: string;
  activityId?: string;
  assignmentId?: string;
  districtId?: string;
  parentId?: string;
  studentId?: string;
  storyId?: string;
  schoolId?: string;
  status?: string;
  displayStatus?: string;
  score_pass?: number;
  tags?: string[];
  createdAt?: string;
  updatedAt?: string;
};

export type AssignmentManifest = {
  activityType?: string;
  storyId?: string;
  locale?: Locale;
  contentTags?: string[];
  status?: AssignmentStatus;
  sequence?: AssignmentSequence;
  activity?: ActivitySummary[];
  skills?: Skill[];
  lessonPeriodType?: LessonPeriodType;
  lessonPeriod?: number;
  launchArgs?: LaunchArg;
};

export type Assignment = {
  assignmentId?: string;
  parentId?: string;
  lessonPlanId?: string;
  periodId?: string;
  assignor?: string;
  entityId?: string;
  entityType: string
  grade?: Grade;
  assignmentType?: string;
  createdAt?: string;
  createdBy?: string;
  changedAt?: string;
  changedBy?: string;
  dateFrom?: string;
  dateTo?: string;
  status?: AssignmentStatus;
  manifest?: AssignmentManifest[];
  resources?: string[];
  curriculumInfo?: CurriculumInfo;
  assignmentCategory?: AssignmentCategory[];
  assignmentName?: string;
  tags?: string[];
};

export type CurriculumInfo = {
  curriculumId?: string;
  curriculumPlanId?: number;
  curriculumSkills?: Skill[];
};

export type EntityAssignmentIds = {
  entityId?: string;
  entityType: string
  assignmentIds?: string[];
};

export type EntityAssignments = {
  entityId?: string;
  assignments?: Assignment[];
};

export type EntityChildEntityAssignmentIds = {
  entityId?: string;
  childEntityAssignments?: EntityAssignmentIds[];
};

export type LaunchArg = {
  storyId?: string;
  skill?: string;
  activityUuid?: string;
  activityOid?: string;
  startingJumpPath?: string;
  endingJumpPath?: string;
  stopBefore?: string;
};

export type Skill = {
  skillId?: string;
  skillType?: string;
  season?: Season;
  isRepeated?: boolean;
  unitName?: string;
  order?: number;
  lessonName?: string;
  lessonPeriodType?: LessonPeriodType;
  lessonPeriod?: number;
};

export type AssignmentManifestInput = {
	activityType?: string;
	storyId?: string;
	locale?: Locale;
	contentTags?: string[];
	sequence?: AssignmentSequence;
	skills?: SkillInput[];
	lessonPeriodType?: LessonPeriodType;
	lessonPeriod?: number;
};

export type AddAssignmentInput = {
	entityId?: string;
	entityType: string;
	grade?: Grade;
	parentId?: string;
	lessonPlanId?: string;
	periodId?: number;
	assignor?: string;
	assignmentType?: string;
  schoolYear?: number;
	dateFrom?: string;
	dateTo?: string;
	manifest?: AssignmentManifestInput[];
	curriculumInfo?: CurriculumInfoInput;
	assignmentCategory?: AssignmentCategory[];
	resources?: string[];
	assignmentName?: string;
  tags?: string[]
};

export type AddStudentInboxAssignmentInput = {
  studentId: string;
  parentId: string;
  manifest?: AssignmentManifestInput[];
};

export type BatchAddAssignmentInput = {
  entityIdList: string[];
  entityType: string
  grade?: Grade;
  parentId?: string;
  lessonPlanId?: string;
  periodId?: string;
  assignor?: string;
  assignmentType?: string;
  dateFrom?: string;
  dateTo?: string;
  manifest?: AssignmentManifestInput[];
  curriculumInfo?: CurriculumInfoInput;
  assignmentCategory?: AssignmentCategory[];
  resources?: string[];
  tags?: string[];
};

export type BatchUpdateAssignmentInput = {
  entityType: string;
  entityId: string;
  assignmentId: string;
  parentId?: string;
  lessonPlanId?: string;
  periodId?: string;
  changedBy?: string;
  dateFrom?: string;
  dateTo?: string;
  status?: AssignmentStatus;
  manifest?: AssignmentManifestInput[];
  resources?: string[];
  assignmentCategory?: AssignmentCategory[];
  assignmentName?: string;
  tags?: string[];
};

export type CurriculumInfoInput = {
  curriculumId?: string;
  curriculumPlanId?: number;
  curriculumSkills?: SkillInput[];
};

export type SkillInput = {
  skillId?: string;
  skillType?: string;
  season?: Season;
  isRepeated?: boolean;
  unitName?: string;
  order?: number;
  lessonName?: string;
  lessonPeriodType?: LessonPeriodType;
  lessonPeriod?: number;
};

export type AssignmentQueryFilter = {
  status?: AssignmentStatus[];
  assignmentType?: string[];
  dateFrom?: string;
  dateTo?: string;
  grade?: Grade;
  includeGradeOfNone?: boolean;
  entityType: string;
  defaultEntities?: DefaultEntity[];
  limit?: number;
  parentEntity?: boolean;
  assignmentId?: string;
  lessonPlanIds?: string[];
  periodIds?: string[];
};

export type DefaultEntity = {
  entityId: string;
  entityType: string
};
